export const apiPath = {
  getCompany: '/account/getcompany',
  getWechatConfig: '/weixin/config',
  cartList: '/cart/list',
  getActivityInfoById: '/cart/activityinfo',
  cartPut: '/cart/put',
  CancelAjax: '/order/CancelAjax',
  doCancel: '/order/doCancel',
  subscribeArriveNotice: '/stockout/stockout',
  getById: 'entrance/cms/getModulesByModuleIds',
  getSeckillInfoNew: 'entrance/cms/getSecKillInfo',
  getSecKillClass: 'entrance/cms/getSecKillClass',
  getSecKillSkuByTimeRegion: 'entrance/cms/getSecKillSkuByTimeRegion',
  getPromotion: 'entrance/cms/getPromotion',
  getMCPriceSsu: 'entrance/cms/getMCPriceSsu',
  applyCreateActivity: 'entrance/cms/applyCreateActivity',
  receiveCoupon: '/coupon/getcouponbyactionid',
  getcouponpage: '/coupon/getcouponpage',
  getRecommendFeed: '/recommend/feed',
  // 摇钱树相关接口
  getLotteryCount: '/lottery/getdrawcount', // 根据活动ID获取用户剩余抽奖次数
  getLotteryLuck: '/lottery/luck', // 点击抽奖
  getLotteryRecords: '/lottery/getrecentlotteryrecord', // 获取本次活动最近中奖记录
  getMyLotteryRecords: '/lottery/getmylotterygift', // 获取我的获奖记录
  getLotteryAds: '/lottery/getlotteryad', // 获取摇钱树广告位
  getGoodsListByDataId: '/search/getgoodslistbydataid', // 获取feed流数据
  // 秒杀相关接口
  getSeckillInfo: '/cms/getseckillinginfo',
  getSeckillSkuByTime: '/cms/getseckillskubytime',
  subscribe: '/subscribe/seckill',
  getGoodsDetail: '/commodity/getskusbyids',
  getSkuCertInfo: '/commodity/certinfo',
  goodsRank: 'entrance/commodity/goodsRank',
  // 领劵中心
  getCouponCenterBanner: '/coupon/getadpic', // 获取领劵中心轮播图
  getCouponCenterList: '/coupon/list', // 领劵中心列表
  receiveCouponInCouponCenter: '/coupon/receivecoupon', // 领劵中心领劵
  centerTop: 'entrance/coupon/centerTop', // 顶部图/优惠券/券包/广告位
  centerTabs: 'entrance/coupon/centerTabs', // 领券中心分类
  centerGetByTab: 'entrance/coupon/centerGetByTab', // 分类下优惠券
  myCouponList: 'entrance/coupon/myCouponList', // 分类下优惠券
  transferCoupon: 'entrance/coupon/transferCoupon', // 分类下优惠券
  listTransferableUnit: 'entrance/account/listTransferableUnit',
  // 商品推荐相关接口
  getGoodsInfoStream: 'entrance/recommend/goodsInfoStream',
  getGoodsInfoLocation: 'entrance/recommend/goodsInfoLocation',

  // 直播列表
  getLiveRooms: 'entrance/liveStream/getRoomList',
  remindLive: 'entrance/liveStream/subscribeRemind',
  // 加入采购清单
  addShopping: 'entrance/smartList/add',
  // 内容产品相关
  contentHome: 'entrance/menu/index/getModulesByRoute', // 内容首页
  contentHomeFeed: 'entrance/menu/index/feed', // 首页feed
  thumbsUp: 'entrance/menu/user/thumbsUp', // 菜谱点赞
  getCreationsList: 'entrance/menu/user/getCreationsList', // 菜用户作品列表
  getConcernList: 'entrance/menu/user/getConcernList', // 关注列表
  getUserInfo: 'entrance/menu/user/getUserInfo', // 用户信息
  getCollectionList: 'entrance/menu/user/getCollectionList', // 用户收藏的列表
  getThumbsUpList: 'entrance/menu/user/getThumbsUpList', // 用户赞过的列表
  getCreationsByActivityId: 'entrance/menu/index/getCreationsByActivityId', // 用户赞过的列表
  concernUp: 'entrance/menu/user/concernUp', // （取消）关注
  getUserId: 'entrance/menu/index/getUserId', // 获取用户ID
  getPlatformRulesCategory: '/cms/getplatformrulescategory',
  getPlatformRules: '/cms/getplatformrules',

  // 账单
  queryBillDetail: '/bill/queryDetails', // 用户账单查询
  queryDetailsByGroupDeliveryDate: '/bill/queryDetailsByGroupDeliveryDate', // 用户账单查询
  queryBillRange: '/bill/query', // 用户账单查询
  exportBillDetail: '/bill/exportDetails', // 导出用户账单
  getBillAnalysis: '/bill/categoryAnalysis', // 统计分析
  downloadFile: '/bill/downloadFile', // 统计分析
  getBillTip: '/bill/getBillTip', // 统计分析
  exportList: '/bill/exportList', // 统计分析
  exportDetails: '/bill/exportDetails', // 统计分析
  getBillCompanyList: '/trade/companyList', // 统计分析

  // account
  pickupCode: 'entrance/account/pickupCode', // 取货码

  polymerizeSaleClass: 'entrance/activity/polymerizeSaleClass', // 活动筛选
  polymerizeProduct: 'entrance/activity/polymerizeProduct', // 活动聚合商品
  getActivityInfo: 'entrance/activity/getActivityInfo', // 活动详情
  // pop
  getShopIndexInfo: 'entrance/pop/getShopIndexInfo',
  getPopSaleClassify: 'entrance/pop/getPopSaleClassify',
  getPopSkuSsuBySaleClass2Id: 'entrance/pop/getPopSkuSsuBySaleClass2Id',
  getPopQualificationPic: 'entrance/pop/getPopQualificationPic',
  getPopQualificationInfo: 'entrance/pop/getPopQualificationInfo',
  // im
  getImRoom: '/im/getimroom',

  // 配送单
  deliveryDetail: '/delivery/detail', // 配送详情
  getWaybillList: '/delivery/getWaybillList', // 配送列表
  getDeliveryVoucher: '/delivery/getDeliveryVoucher', // 配送详情
  // 个人清单
  personalPrivacyList: '/account/personalPrivacyList',

  // 运费相关
  getFreightFeeList: '/order/freightlist',
  getFreightFeeDetail: '/order/freightdetailv2',
  getFreightFeeRules: '/order/freightrule',
  getOrderFeeRules: '/order/feerule',
  orderFeetabs: '/order/feeTabs',
  getFeeRulesDisplay: '/order/feeRulesDisplay',
  // 热销榜
  hotSaleRankInfo: 'entrance/recommend/hotSaleRankInfo',

  // 钥匙管理
  getKeyContent: '/key/get',
  submitKey: '/key/submit',
  // 红包雨
  getDrawCount: '/lottery/getdrawcount',
  getDecreaseDrawCount: '/lottery/decreasedrawcount',
  getLotterResult: '/lottery/luck',
  // 防疫证明
  simpleListforqc: '/order/simpleListforqc',
  getqcbyorderids: '/order/getqcbyorderids',
  // 新品提报
  getNewGoodReqList: '/new-demand/list',
  getNewGoodSuggest: '/search/newdemand',
  getNewGoodReqSaleClass: '/new-demand/saleclass',
  createNewGoodReq: '/new-demand/create',
  getNewGoodReqDetail: '/new-demand/detail',
  getOssKey: 'entrance/oss/getKey',
  // 会员权益
  primeCardBenefits: 'entrance/primeCard/benefits',
  primeCardOrderList: 'entrance/primeCard/orderList',
  primeCardOrderDetail: 'entrance/primeCard/orderDetail',
  primeCardPrePay: 'entrance/primeCard/prePay',
  // 会员积分
  getScoreDetail: `member/getScoreDetail`,
  memberReceiveCoupon: `member/receiveCoupon`,
  scoreExchangeGoods: `member/scoreExchangeGood`, // 我的积分页 积分兑换单个商品
  getScoreExchangeGoodsList: `member/getConvertGoodsList`, // 我的积分页 获取积分可兑换商品列表
  getScoreActivityTask: `member/getScoreActivityTask`, // 积分任务
  receiveIntegralTask: `member/receiveIntegralTask`, // 积分任务
  getScoreRecord: `member/getScoreRecord`,
  queryHasPayingOrders: `member/queryHasPayingOrders`,
  getCouponPackList: `member/getCouponPackList`,
  getCouponPackPayUrl: `entrance/coupon/getCouponPackPayUrl`,
  getAgainCouponPackPayUrl: `entrance/coupon/getAgainCouponPackPayUrl`,
  getCouponPackDetail: `member/getCouponPackDetail`,
  getCouponPackAgainPayUrl: `member/getCouponPackAgainPayUrl`,
  getCouponPackBuyRecord: `member/getCouponPackBuyRecord`,
  // 获取可兑换券列表
  queryScoreCouponActivity: `entrance/primeScore/queryCouponActivity`,
  // 兑换
  exchangeGoods: `entrance/primeScore/exchangeGoods`,
  // 查列表
  queryScoreExchangeGoodsActivity: `entrance/primeScore/queryExchangeGoodsActivity`,
  // 查记录
  queryExchangeTrigger: `entrance/primeScore/queryExchangeTrigger`,
  getCompanyInfo: `account/getcompany`,

  // 查询协议+签署结果
  companyProtocolQuery: 'entrance/account/companyProtocolQuery',
  signProtocol: 'entrance/account/signProtocol',
  userConfig: 'entrance/account/userConfig',
  submitConfig: 'entrance/account/submitConfig',
  // 商户市调
  getTodayTaskList: '/entrance/marketSurvey/queryMerchantTaskList',
  getTaskDetail: '/entrance/marketSurvey/queryMerchantTaskDetail',
  upOcr: '/entrance/marketSurvey/merchantMarket',
  submitTask: '/entrance/marketSurvey/subMerchantTask',
  getRecord: '/entrance/marketSurvey/queryMerchantTaskHistoryList',
  deleteUpOcr: '/entrance/marketSurvey/cancelUpload',
  getCouponInfo: '/entrance/marketSurvey/queryGiveOutCouponConfig',

  // 档口
  configGetByKey: '/entrance/config/getByKey',
  configOperate: '/entrance/config/operate',

  // 家乡菜
  popupHomeCouponList: '/entrance/coupon/popupCouponList',
  getHomeGoodsDetail: '/entrance/config/getByKey',
  applyHomeGoodsDetail: '/entrance/config/operate',
  getHomeCustomPage: '/entrance/cms/customPage',
  getHomeGoodsRank: '/entrance/recommend/goodsInfoLocation'
}
